import React from 'react';
import {
  Stack,
  TableCell,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material';
import convertDecimalToPercentValue from '../../../../../../utils/convertDecimalToPercentValue';
import { CalculatedTVBudget } from '../../../../../../../../../../../store/planStore';

export interface TVReachRowProps {
  data: CalculatedTVBudget;
}

export default function TVReachRow({ data }: TVReachRowProps) {
  const { palette } = useTheme();
  return (
    <TableRow
      sx={{
        background: palette.oohTable.background.reach,
        height: '65px',
        borderTop: '1px solid #cad1dd',
      }}
    >
      <TableCell />
      <TableCell>
        <Stack flexDirection="row" justifyContent="center" pl="25%" gap="48px">
          <Typography variant="body2" fontWeight={700}>
            {data.reach1Plus ? 'TV REACH 1+' : 'N/A'}
          </Typography>
          <Typography
            variant="body2"
            fontWeight={700}
            display="flex"
            flexDirection="column"
          >
            {data.reach1Plus
              ? `${convertDecimalToPercentValue(data.reach1Plus)}%`
              : 'N/A'}
          </Typography>
        </Stack>
        <Stack flexDirection="row" justifyContent="center" pl="25%" gap="48px">
          <Typography variant="body2" fontWeight={700}>
            {data.reach3Plus ? 'TV REACH 3+' : 'N/A'}
          </Typography>
          <Typography
            variant="body2"
            fontWeight={700}
            display="flex"
            flexDirection="column"
          >
            {data.reach3Plus
              ? `${convertDecimalToPercentValue(data.reach3Plus)}%`
              : 'N/A'}
          </Typography>
        </Stack>
      </TableCell>
      <TableCell align="right">-</TableCell>
      <TableCell align="center">-</TableCell>
      <TableCell align="center">-</TableCell>
      <TableCell align="right">-</TableCell>
    </TableRow>
  );
}
